import {useEffect} from '@wordpress/element';

export const useProcessExpressCheckoutError = (
    {
        name,
        onError,
        emitResponse,
        onCheckoutFail,
        messageContext = null,
        activePaymentMethod,
    }) => {
    useEffect(() => {
        const unsubscribe = onCheckoutFail((data) => {
            if (data?.processingResponse.paymentDetails?.stripeErrorMessage) {
                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: data.processingResponse.paymentDetails.stripeErrorMessage,
                    messageContext: messageContext || emitResponse.noticeContexts.EXPRESS_PAYMENTS
                };
            }
            if (name === activePaymentMethod) {
                onError('');
            }
            return null;
        });
        return () => unsubscribe();
    }, [
        name,
        onCheckoutFail,
        messageContext,
        activePaymentMethod,
        emitResponse.responseTypes.ERROR,
        emitResponse.noticeContexts.EXPRESS_PAYMENTS
    ]);
}